<app-headerinner></app-headerinner>
<app-breadcrumb></app-breadcrumb>
<app-content></app-content>
<app-footer [layout]="classname" [logo]="ftlogo"></app-footer>